import styled from "styled-components"

import { WidgetsRowWrapper } from "layouts/WidgetsLayout/WidgetsRowWrapper"
import { WidgetContractors } from "components/widgets/WidgetContractors"
import { WidgetInstaledDevices } from "components/widgets/WidgetInstaledDevices"
import { WidgetPhysicalStatus } from "components/widgets/WidgetPhysicalStatus"
import { WidgetSTAndMemberships } from "components/widgets/WidgetSTAndMemberships"
import { WidgetVendorAlerts } from "components/widgets/WidgetVendorAlerts"
import { WidgetVendorAlertStatuses } from "components/widgets/WidgetVendorAlertStatuses"
import { WidgetVendorOrderStatus } from "components/widgets/WidgetVendorOrderStatus"
import { WidgetWarehouseInformation } from "components/widgets/WidgetWarehouseInformation"

import CustomerTrends from "./components/CustomerTrendsWidget"
import InstallationTrends from "./components/InstallationTrendsWidget"
import ReordersWidget from "./components/ReordersWidget"

const WidgetsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px 16px;
  padding-bottom: 24px;
`

const StyledWidgetsRowWrapper = styled(WidgetsRowWrapper)`
  flex: 1;

  @media only screen and (max-width: 1200px) {
    flex: 1 0 100%;
  }
`

const WidgetsHalfRowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 24px 16px;

  > div > div > div {
    flex: 1 0 100%;
  }
`

export const Dashboard = () => {
  return (
    <WidgetsWrapper>
      <WidgetsRowWrapper title="Devices">
        <WidgetPhysicalStatus />
        <WidgetInstaledDevices />
      </WidgetsRowWrapper>
      <WidgetsRowWrapper title="Trends">
        <InstallationTrends />
        <CustomerTrends />
        <ReordersWidget />
      </WidgetsRowWrapper>
      <WidgetsRowWrapper title="Orders">
        <WidgetWarehouseInformation />
        <WidgetVendorOrderStatus />
      </WidgetsRowWrapper>
      <WidgetsHalfRowWrapper>
        <StyledWidgetsRowWrapper title="Contractors/Integration">
          <WidgetContractors />
          <WidgetSTAndMemberships />
        </StyledWidgetsRowWrapper>
        <StyledWidgetsRowWrapper title="Alerts">
          <WidgetVendorAlerts />
          <WidgetVendorAlertStatuses />
        </StyledWidgetsRowWrapper>
      </WidgetsHalfRowWrapper>
    </WidgetsWrapper>
  )
}
